export default __webpack_public_path__ + "static/media/arcoLogo.cec6f9bb.png";